import { ESentInvoicePaymentStatus } from '@/src/app/core/enums';
import { AppConfigService } from '@/src/app/core/services';
import { Component, inject, Input } from '@angular/core';

@Component({
  selector: 'aup-sent-invoices-payment-status',
  templateUrl: './sent-invoices-payment-status.component.html',
  styleUrls: ['./sent-invoices-payment-status.component.scss'],
  standalone: false,
})
export class SentInvoicesPaymentStatusComponent {
  /**
   * sent invoice status input
   * @date 8/02/2024 - 12:21:58 PM
   *
   * @type {ESentInvoicePaymentStatus}
   */
  @Input() status!: ESentInvoicePaymentStatus;

  /**
   * Statuses map
   *  @date 8/02/2024 - 12:21:58 PM
   */

  sentInvoicesPaymentStatusesMap = inject(AppConfigService).getCountryConfig().sentInvoice.paymentStatusesMap;

}
